import type {SVGProps} from 'react';
import clsx from 'clsx';

export const SearchIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			className={clsx('h-full', 'w-auto')}
			viewBox="0 0 92 93"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M49.0763 69.344H27.582C26.6803 69.344 25.8148 68.9834 25.1729 68.3487L8.66265 51.8384C8.02791 51.1965 7.66727 50.331 7.66727 49.4294V27.9206C7.66727 27.019 8.0207 26.1535 8.66265 25.5187L25.1945 8.90753C25.8364 8.26559 26.702 7.90495 27.6108 7.90495H49.0691C49.9779 7.90495 50.8434 8.26559 51.4854 8.90753L68.0173 25.5187C68.652 26.1607 69.0126 27.019 69.0126 27.9206V49.4294C69.0126 50.331 68.652 51.1965 68.0173 51.8384L51.507 68.3487C50.8651 68.9906 49.9995 69.344 49.0979 69.344M68.5582 62.1384L75.6845 55.0121C76.3264 54.3702 76.6799 53.5046 76.6799 52.603V24.7542C76.6799 23.8526 76.3264 22.987 75.6845 22.3523L54.6735 1.23306C54.0315 0.591112 53.166 0.230469 52.2571 0.230469H24.4228C23.5139 0.230469 22.6484 0.591112 22.0064 1.23306L0.995378 22.3523C0.360646 22.9942 0 23.8526 0 24.7542V52.603C0 53.5046 0.360646 54.3774 0.995378 55.0121L21.9992 76.0159C22.6412 76.6579 23.5067 77.0113 24.4083 77.0113H52.2499C53.1515 77.0113 54.0171 76.6507 54.659 76.0159L61.9079 68.767C62.2397 68.4352 62.7807 68.4352 63.1125 68.767L85.4507 91.1052C86.172 91.8265 87.1457 92.2304 88.1628 92.2304C90.2761 92.2304 92 90.5138 92 88.3932C92 87.3762 91.596 86.4024 90.8748 85.6812L68.5366 63.343C68.2048 63.0112 68.2048 62.4702 68.5366 62.1384"
				fill="currentColor"
			/>
		</svg>
	);
};
